import {
    InteractionRequiredAuthError,
    IPublicClientApplication,
    RedirectRequest,
    ServerError,
} from "@azure/msal-browser";

// Mid-session, a silent token renewal can fail for good (refresh token expired, consent or MFA needed). Every API
// request then failed with "Not authenticated" until the user reloaded, and each caller's unhandled .unwrap() became
// a Sentry event (AC-WEB-1). AuthHandler already sends the user to sign in again when the *first* token fails this
// way; this does the same for a failure inside an API request.
//
// One redirect only: a page fires several queries at once, and every one of them hits the same failure. Starting a
// second interaction while the first is under way is what MSAL rejects with interaction_in_progress (AC-WEB-2).
let redirecting = false;

/** True once a sign-in redirect has been started and the page is about to navigate away. */
export const isAuthRedirecting = () => redirecting;

/**
 * Starts the sign-in redirect for a silent-token failure that needs the user, once. Other failures (a network
 * blip, MSAL misconfiguration) are left to the caller, as before.
 */
export function redirectIfInteractionRequired(pca: IPublicClientApplication, request: RedirectRequest, error: unknown): void {
    if (!(error instanceof InteractionRequiredAuthError || error instanceof ServerError)) return;
    if (redirecting) return;
    redirecting = true;
    pca.acquireTokenRedirect(request).catch(() => {
        // The redirect couldn't start (e.g. AuthHandler started one first); let a later failure try again.
        redirecting = false;
    });
}

/** For tests only. */
export const resetAuthRedirectForTests = () => { redirecting = false; };
